///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.datatables = abcsetup.datatables || {};
abcsetup.datatables.buttons = abcsetup.datatables.buttons || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.datatables.buttons = {
    /**
     * Move the export buttons
     *
     * @param {*} table
     */
    init(table, options = []) {
        var tableWrapper = table.closest('.dataTables_wrapper');

        // Global search is turned off, add the col where it would've been
        if (tableWrapper.find('.dataTables_filter').length == 0) {
            tableWrapper.find('.dataTables_length').after('<div class="dataTables_filter col"></div>')
        }

        // Format the dom info into bootstrap rows and columns
        //tableWrapper.find('.dataTables_length').parent().addClass('row');
        tableWrapper.find('.dataTables_length, .dataTables_filter').wrapAll("<div class='row'></div>");
        tableWrapper.find('.dataTables_info, .dataTables_paginate').wrapAll("<div class='row'></div>");

        tableWrapper.find('.dataTables_length').addClass('col-4'); // Pagination column
        tableWrapper.find('.dataTables_filter').addClass('col'); // Search/Buttons columns
        tableWrapper.find('.dataTables_info, .dataTables_paginate').addClass('col-6'); // Info and pagination buttons columns

        // Find the default buttons
        var btns = tableWrapper.find('.dt-buttons').addClass('ml-1');

        // Format the buttons
        btns.find('.btn-secondary').removeClass('btn-secondary').addClass('btn-outline-secondary btn-sm');
        btns.find('.buttons-create').removeClass('btn-outline-secondary').addClass('btn-primary btn-sm ml-1');
        btns.find('.buttons-back').removeClass('btn-outline-secondary').addClass('btn-secondary btn-sm ml-1');
        btns.find('.buttons-generic').removeClass('btn-outline-secondary').addClass('btn-warning btn-sm ml-1');
        //btns.find('.buttons-export').attr('title', 'Export Table');
        //btns.find('.buttons-csv').attr('title', 'Export to CSV');
        btns.find('.buttons-excel').attr('title', 'Export to Excel');
        btns.find('.buttons-pdf').attr('title', 'Export to PDF');
        btns.find('.buttons-colvis').attr('title', 'Column Visibility').prepend('<i class="far fa-eye mr-1"></i>').find('span').remove();
        btns.find('.buttons-reset').attr('title', 'Reset Table').addClass('ml-3');

        // Format the buttons (v1) ----------------------------------------------------------------
        btns.find('.buttons-csv, .buttons-copy, .buttons-print').remove();
        if (btns.find('.buttons-excel i').length == 0) {
            btns.find('.buttons-excel').attr('title', 'Export to Excel').prepend('<i class="far fa-file-excel mr-2"></i>');
        }

        if (btns.find('.buttons-pdf i').length == 0) {
            btns.find('.buttons-pdf').attr('title', 'Export to PDF').prepend('<i class="far fa-file-pdf mr-2"></i>');
        }
        // ----------------------------------------------------------------------------------------

        // Add the default buttons
        tableWrapper.find('.dataTables_filter').append(btns);
        //tableWrapper.find('.dataTables_filter .dt-buttons').before('<button class="btn btn-sm btn-outline-secondary dt-reset-btn ml-4" title="Reset Table"><i class="fas fa-undo-alt"></i></button>');

        // Move the back button
        tableWrapper.find('.buttons-back').parent().after(tableWrapper.find('.buttons-back'));

        // Move the add button
        tableWrapper.find('.buttons-create').parent().after(tableWrapper.find('.buttons-create'));

        // Move the reset button
        tableWrapper.find('.buttons-reset').parent().before(tableWrapper.find('.buttons-reset'));

        // Move any generic buttons
        tableWrapper.find('.buttons-generic').parent().after(tableWrapper.find('.buttons-generic'));

        // Add tooltips to the global search field
        tableWrapper
            .find('.dataTables_filter input.form-control')
            .attr('title', 'This is a universal search. Begin typing and your search will be narrowed as additional characters are entered.');



        var addText = options['addText'] ? options['addText'] : 'Add New';

        // Add the "Add New" button
        if (options['addBtn']) {
            tableWrapper.find('.dataTables_filter').append('<a href="#" data-href="' + options['addBtn'] + '" class="btn btn-primary btn-sm ml-2 dt-add-new-btn">' + addText + '</a>');
        }

        // Add the "Add New" button linked to a modal
        if (options['addBtnModal']) {
            tableWrapper.find('.dataTables_filter').append('<button class="btn btn-primary btn-sm ml-2" data-toggle="modal" data-target="' + options['addBtnModal'] + '">' + addText + '</button>');
        }

        // Add any extra buttons
        if (options['extraBtns']) {
            $(options['extraBtns']).each(function() {
                tableWrapper.find('.dataTables_filter').append(this);
            });
        }

        if (table.attr('id') == 'app_data_tables_thought_spot_items_form_data_table') {
            tableWrapper.find('.dataTables_scroll').prepend(`
                <div class="row my-2">
                    <div class="col-sm"></div>
                    <div class="col-sm" style="margin-left: 385px; margin-right: 100px;">
                        <div class="card p-2">
                            <div class="d-flex justify-content-center">
                                <span class="font-weight-bold">Would you like to extend discounts to these customers?</span>
                            </div>
                        </div>
                    </div>
                </div>
            `);
        }
    },
}
